<a class="cc-icon cc-icon-close close-modal" aria-label="Close" (click)="onCloseModal()"></a>

<!-- Notification -->
<div class="loaded-container w-100">
  <header>
    <h1 class="h1" i18n>Your Sitemate Link has been successfully {{ taskCreationMode }}!</h1>
  </header>
  <p class="mt-4 mb-2">Before continuing, please note the following warnings:</p>
  <div class="warning-info-table">
    <div class="d-flex warning-info-item" *ngFor="let warning of localWarnings">
      <div class="warning-icon"><i class="cc-icon cc-icon-warning"></i></div>
      <p class="default-paragraph warning-description">
        <strong>{{ warning.templateName }}</strong> {{ warning.description }}
      </p>
      <div class="warning-learn-more">
        <a
          href="https://intercom.help/dashpivot/en/articles/5278836-template-links"
          target="_blank"
          class="btn btn-sm cc-btn-subtle-gray"
        >
          <i class="mr-1 cc-icon cc-icon-question"></i><span>Learn more</span>
        </a>
      </div>
    </div>
  </div>
  <div class="mt-2 text-center">
    <button
      class="mt-1 btn btn-md cc-btn-subtle-blue-helper acknowledge btn-extra-padding"
      (click)="onAcknowledge()"
    >
      OK
    </button>
  </div>
</div>
